import Axios from "axios"

export default {

  /**
   * 参数详情
   */
  paramInfo() {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/customer/searchField`);
  },

  /**
   * 列表
   * @param {*} gender 
   * @param {*} age_range_min 
   * @param {*} age_range_max 
   * @param {*} page
   */
  listPage(
    gender,
    age_range_min,
    age_range_max,
    visit_first_date_start,
    visit_first_date_end,
    page
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/customer/page`, {
      params: {
        gender,
        age_range_min,
        age_range_max,
        visit_first_date_start,
        visit_first_date_end,
        page
      }
    });
  },

  /**
   * 详情
   * @param {*} customerId 
   */
  info(
    customerId
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/customer/${customerId}`);
  },

  /**
   * 轨迹列表
   * @param {*} customerId 
   */
  logList(
    customerId
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/customer/${customerId}/project/visit`);
  },

  /**
   * 轨迹详情
   * @param {*} customerId 
   * @param {*} projectId 
   */
  logInfo(
    customerId,
    projectId
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/customer/${customerId}/project/${projectId}/visit/day`);
  },

  /**
   * 轨迹详情列表
   * @param {*} customerId 
   * @param {*} projectId 
   * @param {*} day 
   */
  logInfoList(
    customerId,
    projectId,
    day
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/customer/${customerId}/project/${projectId}/visit/day/${day}`);
  },

  /**
   * 到访客户列表
   * @param {*} visit_date_start 
   * @param {*} visit_date_end 
   * @param {*} page 
   */
  visitListPage(
    visit_date_start,
    visit_date_end,
    page
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/customer/visit/page`, {
      params: {
        visit_date_start,
        visit_date_end,
        page
      }
    });
  }

}